export default {
  api: '/'
};
